import React, { forwardRef } from 'react';
import { Button, ButtonProps } from 'primereact/button';
import {useDynamicButtonStyle} from "@Utils/hooks/useDynamicButtonStyle";

interface ThemeButtonProps extends ButtonProps {
  children?: any;
  themeButtonStyleProps?: any;
  onClick?: any;
  icon?: string;
  className?: string;
}

const ThemeButton = forwardRef<HTMLButtonElement, ThemeButtonProps>((props, ref) => {
  const { type, children, themeButtonStyleProps, onClick, icon, style, className } = props;
  const themeButtonStyle = useDynamicButtonStyle(themeButtonStyleProps);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button
      {...props}
      ref={ref as any}
      type={type}
      style={{ ...themeButtonStyle, ...style }}
      onClick={onClick}
      icon={icon}
      className={className}
    >
    {children}
    </Button>
  );
});

export default ThemeButton;
